import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFileCardCopy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13 10.5H7a.5.5 0 0 1-.5-.5V2c0-.275.225-.5.5-.5h4.378L13.5 3.622V10c0 .275-.225.5-.5.5M7 12h6c1.103 0 2-.897 2-2V3.622a1.5 1.5 0 0 0-.44-1.06L12.44.442A1.5 1.5 0 0 0 11.382 0H7C5.897 0 5 .897 5 2v8c0 1.103.897 2 2 2M3 4c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h6c1.103 0 2-.897 2-2v-1H9.5v1c0 .275-.225.5-.5.5H3a.5.5 0 0 1-.5-.5V6c0-.275.225-.5.5-.5h1V4z"
    />
  </svg>
);
export default SvgFileCardCopy;
